// config
// dependencies
import { GenerateProcess } from "redux-process";

// actions
import { StateChange } from "../../../actions/page.actions";

import { getPageName } from "../../../selectors/navigation";
// selectors
import { getJobID } from "./selectors";

import ui from "./ui";

/**
 * Get the job from the server.
 */
export const getJob = () => async (dispatch, getState) => {
	const state = getState();
	const jobID = getJobID(state);
	const pageName = getPageName(state);

	const request = await dispatch(GenerateProcess("GetJob", { jobID }));

	if (request.succeeded) {
		dispatch(StateChange(pageName, ["job"], request.response));
	}
};

export const initialize = () => (dispatch, getState) => {
	const state = getState();
	const pageName = getPageName(state);

	dispatch(StateChange(pageName, [], ui));
	dispatch(getJob());
};
